export default __webpack_public_path__ + "static/media/addEmoji.0d1e400c.png";